import { Box, CircularProgress } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

import { LoanEstimate } from '@/components/LoanEstimate/LoanEstimate';
import { useProperty } from '@/hooks/useProperty';

/**
 * The loan program comparison and closing costs live on the property page's
 * Qualify step. A buyer whose property has reached Qualify is sent there; the
 * standalone page remains for properties still in Shop and for admins viewing
 * someone else's property.
 */
export const LoanEstimatePage = () => {
  const { productId } = useParams();
  const { property, product, user, isLoading } = useProperty(productId);
  const ownerId =
    typeof product?.user === 'string' ? product.user : product?.user?._id;
  const isOwner = Boolean(user?._id && ownerId === user._id);

  if (!productId) return null;

  if (isLoading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (
    property &&
    property.pipelineMode === 'buyer' &&
    isOwner &&
    property.stage >= 2
  ) {
    return <Navigate to={`/properties/${property.id}/stage/2`} replace />;
  }

  return <LoanEstimate productId={productId} />;
};
